export default "__VITE_PUBLIC_ASSET__9739bcd8__"